import { useState } from "react";
import useMethodSystem from "../useMethodSystem";
import { Button, Input } from "@oc-labs/wt-storybook";
import toast from "react-hot-toast";

export default function TransactionsConfig({}) {
  const { transactions, setTransactions } = useMethodSystem();
  const [newTransaction, setNewTransaction] = useState({
    abi: "",
    address: "",
    parameters: [],
    method: ""
  });

  const handleDeleteTransaction = (index) => {
    const updatedTransactions = transactions.filter((_, i) => i !== index);
    setTransactions(updatedTransactions);
  }

  return (<div className="">
    <p className="mt-4 text-[12px]">Configure checkout transactions</p>
    {transactions.map((tx, index) => (<div key={index} className="mt-2 p-2 border border-gray-300 rounded-md">
      <div className="flex justify-between items-center">
        <p className="text-xs mb-2">Transaction {index + 1}</p>
        <div className="">
          <Button
            type="danger"
            size="small"
            onClick={() => handleDeleteTransaction(index)}
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-4 mb-2">
        <div className="flex flex-col">
          <p><strong>Method</strong></p>
          <p>{tx.method}</p>
        </div>
        <div className="flex flex-col">
          <p><strong>Contract Address</strong></p>
          <p>{tx.address}</p>
        </div>
        <div className="flex flex-col">
          <p><strong>ABI</strong></p>
          <p>{tx.abi}</p>
        </div>
      </div>
        
      
      <p><strong>Parameters:</strong> {tx.parameters.join(", ")}</p>
    </div>
    ))}
    <div className=" items-center gap-3 rounded-md cursor-pointer transition-colors bg-gray-150 hover:bg-gray-150 border border-gray-300 mt-2 p-2" >
      <div className="flex-1 grid grid-cols-3 items-center gap-4">
        <Input
          placeholder="Method Name"
          value={newTransaction.method}
          onChange={(e) => setNewTransaction({
            ...newTransaction,
            method: e.target.value
          })}
        />
        <Input
          placeholder="Contract Address"
          value={newTransaction.address}
          onChange={(e) => setNewTransaction({
            ...newTransaction,
            address: e.target.value
          })}
        />
        <select
          className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          value={newTransaction.abi}
          onChange={(e) => setNewTransaction({
            ...newTransaction,
            abi: e.target.value
          })}
        >
          <option value="">Select ABI</option>
          <option value="erc20">ERC20</option>
          <option value="erc721">ERC721</option>
          <option value="custom">Custom</option>
        </select>

        {newTransaction?.parameters?.length > 0 && <div className="col-span-3 gap-2">
          {newTransaction.parameters.map((param, idx) => (
            <div key={idx} className="inline-block bg-gray-200 text-gray-800 px-2 py-1 rounded-full text-sm mr-2">
              {param}
            </div>
          ))}
        </div>}

        <div className="col-span-3">
          <Input
            placeholder="Parameters (comma separated)"
            value={newTransaction.parameters.join(",")}
            onChange={(e) => setNewTransaction({
              ...newTransaction,
              parameters: e.target.value.split(",").map(param => param.trim())
            })}
          />
        </div>
      </div>
      <div className="my-4">
        <Button
          size="small"
          type="secondary"
          onClick={() => {
            if (!newTransaction.method || !newTransaction.address || !newTransaction.abi) return toast.error("Please fill in all transaction fields");
            setTransactions([...transactions, newTransaction]);
            setNewTransaction({
              abi: "",
              address: "",
              parameters: [],
              method: ""
            });
          }}
        >
          Add Transaction
        </Button>
      </div>
    </div>
  </div>);
}